import React from 'react';
import Home from './Home';

const HomeComponent = () => <Home />;

export default HomeComponent;
